import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
const _excluded = ["value", "data", "onChange", "readOnly", "disabled", "justify", "async", "getDisabled"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useFormCommonProps } from '@isyc-react/form/modules/context/form-common';
import { InputLocator } from '@isyc-react/form/modules/input/locator';
import { InputNumber } from '@isyc-react/form/modules/input/number';
import { InputSwitch } from '@isyc-react/form/modules/input/option/switch';
import { InputText } from '@isyc-react/form/modules/input/text';
import { ParameterType, ParameterVisualizationMode } from '@isyc-react/types';
import { InputParameterDate, InputParameterDefaultValues, InputParameterSelect, InputParameterSelectAsync } from "./base";
import { InputCheckbox } from '@isyc-react/form/modules/input/option/checkbox';

// Todos los parametros tienen un labelParameter
// Y el dataType para distinguir entre los siguientes tipos:
// Si no tiene parameterChildId entonces se coge labelParameter y es un parametro simple (todos menos multiparam)

// public static final int STRING_TYPE = 1;
//   -> InputText

// public static final int INTEGER_TYPE = 2;
//   -> InputNumber (allowDecimals: false)

// public static final int DECIMAL_TYPE = 3;
//   -> InputNumber (allowDecimals: true, ->decimalFormat:regex blabla)

// public static final int DATE_TYPE = 4;
//   -> InputDate DD/MM/YYYY -> Se guarda como: YYYYMMDD

// public static final int DEFAULT_VALUES_TYPE = 5;
//   -> InputSelect -> Vendria de consulta a un combo (ese endpoint aun no esta en graphql -> No hacerlo)
//       -> Si tiene valor el value estará en dataValue y el label en comboCodeLabel

// public static final int DEFAULT_VALUES_ITEMS_TYPE = 6;
//   -> Mismo que arriba (datos del combo) pero se muestra con CheckButtonList que hice con Alvaro hace no mucho

// public static final int MULTIFIELD_TYPE = 7;
//   -> NUNCA EXISTIRÁ -> que tenga parameterChildId es lo que indicará que forma parte de un multiparametro

// public static final int LOCATOR_TYPE = 8;
//   -> Locator
//   -> Si tiene valor el id estará en dataValue, el objectTypeId en el campo relatedObjectType y el nombre en relatedObjectName
// urlLocator example: /newspring/modules/core/personLocator
// urlDetail example: /newspring/modules/core/person

// public static final int DATETIME_TYPE = 9;
//   -> Mismo que 4 pero con horas y minutos DD/MM/YYYY HH:mm -> Se guarda como: YYYYMMDDHHmm

// public static final int BOOLEAN_TYPE = 10;
//   -> Este podría ser checkbox o Switch (casi mejooor)
//     -> Vendrá en el dataValue como 'true' o 'false'

// TODO funcionalidad nueva de parametros encriptados hace falta tocar algo o viene el dataValue ya cambiado??
export const getParameterDisabled = (data, readOnly, disabled) => readOnly || disabled || !data.editable;
export const InputParameter = props => {
  const _useFormCommonProps = useFormCommonProps(props),
    {
      value,
      data,
      onChange,
      readOnly,
      disabled,
      justify,
      async = false,
      getDisabled = getParameterDisabled
    } = _useFormCommonProps,
    rest = _objectWithoutProperties(_useFormCommonProps, _excluded);
  // TODO use comboCodeLabel as default selected label in the select and defaultvalues options
  const {
    parameterId,
    parameterType,
    visualizationMode,
    obligatory,
    comboCodeLabel,
    relatedObjectName,
    relatedObjectType
  } = data;
  const {
    value: parameterValue
  } = value;
  const parameterDisabled = React.useMemo(() => getDisabled(data, readOnly, disabled), [data, readOnly, disabled]);
  const parameterChange = React.useCallback(field => {
    onChange && onChange(_objectSpread(_objectSpread({}, value), field));
  }, [value, onChange]);
  switch (parameterType) {
    case ParameterType.STRING_TYPE:
      return /*#__PURE__*/React.createElement(InputText, _extends({
        value: parameterValue,
        onChange: c => parameterChange({
          value: c
        }),
        disabled: parameterDisabled
      }, rest));
    case ParameterType.INTEGER_TYPE:
      return /*#__PURE__*/React.createElement(InputNumber, _extends({
        value: parameterValue ? Number(parameterValue) : undefined,
        onChange: c => {
          var _c$toString;
          return parameterChange({
            value: (_c$toString = c === null || c === void 0 ? void 0 : c.toString()) !== null && _c$toString !== void 0 ? _c$toString : ''
          });
        },
        disabled: parameterDisabled,
        allowDecimals: false,
        allowNegative: true,
        allowLeadingZeros: true
      }, rest));
    case ParameterType.DECIMAL_TYPE:
      return /*#__PURE__*/React.createElement(InputNumber, _extends({
        value: parameterValue ? Number(parameterValue) : undefined,
        onChange: c => {
          var _c$toString2;
          return parameterChange({
            value: (_c$toString2 = c === null || c === void 0 ? void 0 : c.toString()) !== null && _c$toString2 !== void 0 ? _c$toString2 : ''
          });
        },
        disabled: parameterDisabled,
        allowDecimals: true,
        allowedDecimalSeparators: [',', '.'],
        allowNegative: true,
        allowLeadingZeros: true
      }, rest));
    case ParameterType.DEFAULT_VALUES_TYPE:
    case ParameterType.DEFAULT_VALUES_MULTISELECT_TYPE:
      switch (visualizationMode) {
        case ParameterVisualizationMode.COMBO:
          return async ? /*#__PURE__*/React.createElement(InputParameterSelectAsync, _extends({
            value: parameterValue !== null && parameterValue !== void 0 ? parameterValue : null,
            valueText: comboCodeLabel,
            onChange: c => parameterChange({
              value: c
            }),
            parameterId: parameterId,
            required: obligatory,
            disabled: parameterDisabled,
            multi: parameterType === ParameterType.DEFAULT_VALUES_MULTISELECT_TYPE
          }, rest)) : /*#__PURE__*/React.createElement(InputParameterSelect, _extends({
            value: parameterValue !== null && parameterValue !== void 0 ? parameterValue : null,
            onChange: c => parameterChange({
              value: c
            }),
            parameterId: parameterId,
            required: obligatory,
            disabled: parameterDisabled,
            multi: parameterType === ParameterType.DEFAULT_VALUES_MULTISELECT_TYPE
          }, rest));
        case ParameterVisualizationMode.BUTTONS:
          return /*#__PURE__*/React.createElement(InputParameterDefaultValues, _extends({
            value: parameterValue,
            onChange: c => parameterChange({
              value: c
            }),
            parameterId: parameterId,
            required: obligatory,
            disabled: parameterDisabled,
            justify: justify,
            max: parameterType === ParameterType.DEFAULT_VALUES_TYPE ? 1 : undefined
          }, rest));
        default:
          return /*#__PURE__*/React.createElement(React.Fragment, null);
      }
    case ParameterType.DATE_TYPE:
      return /*#__PURE__*/React.createElement(InputParameterDate, _extends({
        visibleFormat: "DD/MM/YYYY",
        visibleNumberFormat: "##/##/####",
        storeFormat: "DD/MM/YYYY",
        enableTime: false,
        value: parameterValue,
        onChange: c => parameterChange({
          value: c
        }),
        disabled: parameterDisabled
      }, rest));
    case ParameterType.LOCATOR_TYPE:
      return /*#__PURE__*/React.createElement(InputLocator, _extends({
        objectTypeId: relatedObjectType,
        value: parameterValue && relatedObjectName ? {
          id: parameterValue,
          value: relatedObjectName,
          active: true
        } : null,
        onChange: c => {
          var _c$id, _c$value;
          return parameterChange({
            value: (_c$id = c === null || c === void 0 ? void 0 : c.id) !== null && _c$id !== void 0 ? _c$id : '',
            relatedObjectName: (_c$value = c === null || c === void 0 ? void 0 : c.value) !== null && _c$value !== void 0 ? _c$value : ''
          });
        },
        disabled: parameterDisabled
      }, rest));
    case ParameterType.DATETIME_TYPE:
      return /*#__PURE__*/React.createElement(InputParameterDate, _extends({
        visibleFormat: "DD/MM/YYYY HH:mm",
        visibleNumberFormat: "##/##/#### ##:##",
        storeFormat: "DD/MM/YYYY[T]HH:mm",
        enableTime: true,
        value: parameterValue,
        onChange: change => parameterChange({
          value: change
        }),
        disabled: parameterDisabled
      }, rest));
    case ParameterType.BOOLEAN_TYPE:
      switch (visualizationMode) {
        case ParameterVisualizationMode.SLIDER:
          return /*#__PURE__*/React.createElement(InputSwitch, _extends({
            value: parameterValue === 'true',
            onChange: change => parameterChange({
              value: change ? 'true' : 'false'
            }),
            disabled: parameterDisabled
          }, rest));
        case ParameterVisualizationMode.CHECK:
          return /*#__PURE__*/React.createElement(InputCheckbox, _extends({
            value: {
              checked: parameterValue === 'true'
            },
            onChange: change => parameterChange({
              value: change.checked ? 'true' : 'false'
            }),
            disabled: parameterDisabled
          }, rest));
        default:
          return /*#__PURE__*/React.createElement(React.Fragment, null);
      }
    case ParameterType.UNKNOWN:
    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};